import { IconButton } from '../../IconButton/index.js'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { FORMAT_TEXT_COMMAND } from 'lexical'

export const StrikeThrough = ({ isStrikethrough, disabled, size }) => {
  const [editor] = useLexicalComposerContext()

  return (
    <IconButton
      tooltip="Strikethrough"
      size={size}
      keyHint="Cmd+Shift+S"
      keyHintVisualOnly
      toggled={isStrikethrough}
      icon="strikethrough-text"
      onClick={() => {
        editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'strikethrough')
      }}
      disabled={disabled}
    />
  )
}
